import { StanModal } from '@/components';

interface DeleteAutomationModalProps {
    isOpen: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export const DeleteAutomationModal = ({ isOpen, onConfirm, onCancel }: DeleteAutomationModalProps) => {
    return (
        <StanModal
            id='delete-automation-modal'
            isOpen={isOpen}
            onClose={onCancel}
            title='Are you sure?'
            size='sm'
            primaryActionLabel='Delete Auto-Reply'
            secondaryActionLabel='Cancel'
            primaryActionColor='destructive'
            secondaryActionColor='secondary'
            onPrimaryAction={onConfirm}
            onSecondaryAction={onCancel}
            hideCloseButton
        >
            <p className='text-dark text-caption-1-regular text-center'>
                Just confirming that you want to delete this automation. This action cannot be undone.
            </p>
        </StanModal>
    );
};
